import { render, staticRenderFns } from "./LiquidationDetail.vue?vue&type=template&id=449f0542&"
import script from "./LiquidationDetail.vue?vue&type=script&lang=js&"
export * from "./LiquidationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports